import { StatusAprovacao } from '@acme/core'
import { Grid } from '@mui/material'
import { FormField, FormFieldSelect, FormFile } from 'global/components/Form'
import { OrigemRegistro } from 'global/components/OrigemRegistro'
import { useFormContext } from 'react-hook-form'
import { match } from 'ts-pattern'
import { AutocompleteDescricaoAbono } from './NovoAbono'

export default function FormDetalhesAbono() {
    const { watch } = useFormContext()
    const [origem, statusAprovacao] = watch(['origem', 'statusAprovacao'])

    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <FormField name="data" label="Data" type="date" required />
            </Grid>
            <Grid item xs={6}>
                <FormField
                    name="quantidadeHoras"
                    label="Horas abonadas"
                    required
                />
            </Grid>
            <Grid item xs={6}>
                <OrigemRegistro origemId={origem} />
            </Grid>
            <Grid item xs={6}>
                <FormFieldSelect
                    name="tipo"
                    label="Tipo"
                    options={[
                        { label: 'Normal', value: 'NORMAL' },
                        {
                            label: 'Saúde ocupacional',
                            value: 'SAUDE_OCUPACIONAL',
                        },
                    ]}
                />
            </Grid>
            <Grid item xs={12}>
                <AutocompleteDescricaoAbono />
            </Grid>
            <FormField name="id" sx={{ display: 'none' }} />
            <Grid item xs={12}>
                <FormFile name="fileUrl" disabled />
            </Grid>
            {match(statusAprovacao)
                .with(StatusAprovacao.PENDENTE, () => (
                    <Grid item xs={12}>
                        <FormField
                            name="justificativa"
                            label="Motivo da inclusão"
                            multiline
                            disabled
                        />
                    </Grid>
                ))
                .with(StatusAprovacao.PENDENTE_EXCLUSAO, () => (
                    <Grid item xs={12}>
                        <FormField
                            name="MotivoExclusao.motivo"
                            label="Motivo da exclusão"
                            multiline
                            disabled
                        />
                    </Grid>
                ))
                .otherwise(() => (
                    <Grid item xs={12}>
                        <FormField
                            name="justificativa"
                            label="Justificativa"
                            multiline
                        />
                    </Grid>
                ))}
        </Grid>
    )
}
